var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
var useStyles = makeStyles(function (_a) {
    var spacing = _a.spacing;
    return ({
        root: {
            display: "flex",
            justifyContent: "left",
            flexWrap: "wrap",
            "& > *": {
                margin: spacing(0.5, 1, 0.5, 0), // Half spacing on top and bottom to avoid negative margins
            },
            "label + [class*='MuiInputBase-formControl'] > [class*='MuiSelect-selectMenu'] > &": {
                marginTop: spacing(-0.5),
                marginBottom: spacing(-0.5),
            },
        },
        medium: {
            "& > *": {
                margin: spacing(1, 2, 1, 0),
            },
        },
    });
}, { name: "EuiChipContainer" });
export var ChipContainer = React.forwardRef(function ChipContainer(_a, ref) {
    var _b;
    var className = _a.className, _c = _a.spacing, spacing = _c === void 0 ? "small" : _c, _d = _a.role, role = _d === void 0 ? "list" : _d, childrenProp = _a.children, props = __rest(_a, ["className", "spacing", "role", "children"]);
    var classes = useStyles();
    // Accessibility roles added to children by default
    var children = React.Children.map(childrenProp, function (child) {
        if (!React.isValidElement(child))
            return null;
        if (child.type && child.type === React.Fragment)
            return child;
        return React.cloneElement(child, __assign({ role: "listitem" }, child.props));
    });
    return (React.createElement("div", __assign({}, props, { className: clsx(classes.root, (_b = {}, _b[classes.medium] = spacing === "medium", _b), className), role: role, ref: ref }), children));
});
//# sourceMappingURL=ChipContainer.js.map